<template>
	<v-container fluid>
		<v-combobox
			v-model="selectedTags"
			:items="allTags"
			hide-selected
			:label="$t('pages.createGame.addTag')"
			multiple
			small-chips
			solo
			item-text="name"
			item-value="id"
		>
			<template v-slot:no-data>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>
							{{$t('pages.createGame.createTag.line1')}}
							<kbd>enter</kbd>
							{{$t('pages.createGame.createTag.line2')}}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
			<template v-slot:selection="{ attrs, item, parent, selected }">
				<v-chip v-if="item === Object(item)" v-bind="attrs" :input-value="selected" label small>
					<span class="pr-2">{{ item.name }}</span>
					<v-icon small @click="parent.selectItem(item)">close</v-icon>
				</v-chip>
				<v-chip v-else v-bind="attrs" :input-value="selected" label small>
					<span class="pr-2">{{ item }}</span>
					<v-icon small @click="parent.selectItem(item)">close</v-icon>
				</v-chip>
			</template>
		</v-combobox>
	</v-container>
</template>

<script>
import { types as TagsTypes } from "dev/store/modules/Tag.module";

export default {
	props: {
		initialTags: {
			type: Array,
			required: false
		}
	},
	data() {
		return {
			selectedTags: [],
			allTags: []
		};
	},
	created() {
		this.$store.dispatch(TagsTypes.FETCH).then(res => (this.allTags = res));
		this.selectedTags = this.initialTags;
	},
	watch: {
		selectedTags(newArray) {
			this.$emit("input", newArray);
		}
	}
};
</script>
